import { NgModule } from "@angular/core";
import { Route, RouterModule } from "@angular/router";
import { CellComponent } from "src/app/view/student-corner/cell/cell.component";
import { EntrepreneurshipCellComponent } from "src/app/view/student-corner/cell/entrepreneurship-cell/entrepreneurship-cell.component";
import { EqualOpportunityCellComponent } from "src/app/view/student-corner/cell/equal-opportunity-cell/equal-opportunity-cell.component";
import { CoPoComponent } from "src/app/view/student-corner/co-po/co-po.component";
import { ConsultComponent } from "src/app/view/student-corner/consult/consult.component";
import { FeedbackComponent } from "src/app/view/student-corner/feedback/feedback.component";
import { GrieveanceComponent } from "src/app/view/student-corner/grieveance/grieveance.component";
import { ImportantLinkComponent } from "src/app/view/student-corner/important-link/important-link.component";
import { PropectusComponent } from "src/app/view/student-corner/propectus/propectus.component";
import { RagingComponent } from "src/app/view/student-corner/raging/raging.component";
import { StudentCornerComponent } from "src/app/view/student-corner/student-corner.component";
import { PlacementCellComponent } from "src/app/view/student-corner/placement-cell/placement-cell.component";
import { HealthFacilitiesComponent } from "src/app/view/student-corner/health-facilities/health-facilities.component";
import { DifferentlyAbledFacilitiesComponent } from "src/app/view/student-corner/differently-abled-facilities/differently-abled-facilities.component";
const route: Route[] = [
    {
        path: '', component: StudentCornerComponent, children: [
            { path: 'anti-ragging', component: RagingComponent },
            { path: 'prospectus', component: PropectusComponent },
            { path: 'consult', component: ConsultComponent },
            { path: 'student-feedback', component: FeedbackComponent },
            { path: 'important-links', component: ImportantLinkComponent },
            { path: 'grievance', component: GrieveanceComponent },
            { path: 'cell', component: CellComponent },
            { path: 'entrepreneurship-cell', component: EntrepreneurshipCellComponent },
            { path: 'equal-opportunity-cell', component: EqualOpportunityCellComponent },
            { path: 'placement-cell', component: PlacementCellComponent },
            { path: 'health-facilities', component: HealthFacilitiesComponent },
            { path: 'differently-abled-facilities', component: DifferentlyAbledFacilitiesComponent },
            // {path:'co-po',component:CoPoComponent},
        ]
    }
]
@NgModule({
    imports: [
        RouterModule.forChild(route)
    ],
    exports: [
        RouterModule
    ]
})
export class StudentCornerRoutingModule { }